import React from 'react';
import styled from 'styled-components';

const CustomTabsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const CustomTabsTabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 3px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  font-size: 16px;
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  background-color: ${({ isActive, activeColor, inactiveColor }) =>
    isActive ? activeColor : inactiveColor};
  color: ${({ isActive, activeTextColor, inactiveTextColor }) =>
    isActive ? activeTextColor : inactiveTextColor};
  transition: all 0.2s ease;

  .label-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;

    .label {
      font-weight: 500;
    }

    .circle-button {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #fff;
    }
  }

`;

const Count = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  height: 22px;
  border-radius: 50%;
  color: ${({ isActive, activeCountColor, inactiveCountColor }) =>
    isActive ? activeCountColor : inactiveCountColor};
`;

const ContentWrapper = styled.div`
  padding: 16px;
  border-radius: 12px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
`;

const CustomTabs = ({ tabs, activeTab, onTabClick }) => {
    const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content;
  return (
    <CustomTabsWrapper>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <CustomTabsTabButton
            key={tab.id}
            isActive={isActive}
            onClick={() => onTabClick(tab.id)}
            activeColor={tab.activeBg}
            inactiveColor={tab.inactiveBg}
            width={tab.width}
            activeTextColor={tab.activeText}
            inactiveTextColor={tab.inactiveText}
          >
            <div className='label-wrapper'>
              {isActive && <span className="circle-button" />}
              <span className='label'>{tab.label}</span>
            </div>
            {(!!tab.count || tab.count === 0) && <Count
              isActive={isActive}
              activeBorderColor={tab.activeBorder}
              inactiveBorderColor={tab.inactiveBorder}
              activeCountBg={tab.activeCountBg}
              inactiveCountBg={tab.inactiveCountBg}
              activeCountColor={tab.activeCountText}
              inactiveCountColor={tab.inactiveCountText}
            >
              {tab.count}
            </Count>}
          </CustomTabsTabButton>
        );
      })}
       {activeTabContent && (
        <ContentWrapper>
          {typeof activeTabContent === 'function'
            ? activeTabContent()
            : activeTabContent}
        </ContentWrapper>
      )}
    </CustomTabsWrapper>
  );
};

export default CustomTabs;
